import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { checkCreatorCode } from "@/lib/admin-api";

// /c/CODE: remembers a creator's invite code, then sends the visitor to the waitlist
export default function CreatorLinkPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const clean = (code ?? "").toUpperCase();
    const go = () => navigate("/#waitlist", { replace: true });
    if (!/^[A-Z0-9]{4,24}$/.test(clean)) { go(); return; }
    checkCreatorCode(clean)
      .then((r) => {
        window.localStorage.setItem("lunelle-ref", clean);
        toast(`Invited by ${r?.name ?? "a Lunelle creator"}`, { description: "Join the waitlist below to save your spot." });
      })
      .catch(() => {})
      .finally(go);
  }, [code, navigate]);
  return <div className="min-h-screen" data-testid="creator-link-page" />;
}
